// UserContext.js
// import { TOKEN_KEY } from 'api';
import { createOne, getAll } from 'api/users';
import { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from './AuthContext';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const [state, setState] = useState({
    fetching: true,
    isLoading: false,
    users: [],
    agents: [],
    usersStats: null
  });

  const getAllUsers = async () => {
    try {
      const { data } = await getAll();
      const userUsers = data.users.filter(el => el.role === 'user');
      const agentUsers = data.users.filter(el => el.role === 'agent');

      const currentDate = new Date();
      const userUsersThisMonth = userUsers.filter(user => {
        const userCreateDate = new Date(user.created_date);
        return (
          userCreateDate.getMonth() === currentDate.getMonth() &&
          userCreateDate.getFullYear() === currentDate.getFullYear()
        );
      });

      const userUsersThisYear = userUsers.filter(user => {
        return (
          new Date(user.created_date).getFullYear() ===
          currentDate.getFullYear()
        );
      });
      setState({
        fetching: false,
        users: userUsers,
        agents: agentUsers,

        usersStats: {
          ...data.usersStats,
          totalUserRole: +userUsers.length,
          totalUserRoleThisMonth: +userUsersThisMonth.length,
          totalUserRoleThisYear: +userUsersThisYear.length
        }
      });
    } catch (err) {
      console.error(err);
    } finally {
      setState(st => ({
        ...st,
        fetching: false
      }));
    }
  };

  const updateAgent = (id, userInfo) => {
    setState(st => ({
      ...st,
      agents: st.agents.map(agent => {
        if (agent.id === id) return { ...agent, ...userInfo };
        return agent;
      })
    }));
  };

  const updateUser = (id, userInfo) => {
    setState(st => ({
      ...st,
      users: st.users.map(user => {
        if (user.id === id) return { ...user, ...userInfo };
        return user;
      })
    }));
  };

  const deleteUser = id => {
    setState(st => ({
      ...st,
      users: st.users.filter(user => user.id !== id)
    }));
  };
  const deleteAgent = id => {
    setState(st => ({
      ...st,
      agents: st.agents.filter(user => user.id !== id)
    }));
  };

  const addUser = async (userInfo, role) => {
    setState(st => ({ ...st, isLoading: true }));
    try {
      const { data } = await createOne({ ...userInfo, role });

      if (role === 'agent')
        setState(st => ({
          ...st,
          isLoading: false,
          agents: [...st.agents, data.user]
        }));
      else
        setState(st => ({
          ...st,
          isLoading: false,
          users: [...st.agents, data.user]
        }));
      toast.success(
        `${role === 'agent' ? 'Agent' : 'User'} created successfully`
      );
      return 'success';
    } catch (err) {
      toast.error(
        `${err}`
      );
      setState(st => ({
        ...st,
        isLoading: false,
      }));
      return 'failed';
    } finally {
      setState(st => ({
        ...st,
        fetching: false
      }));
    }
    // setState((st) => ({
    //   ...st,
    //   users: st.users.filter((user) => user.id !== id),
    // }));
  };

  useEffect(() => {
    if (isLoggedIn) getAllUsers();
  }, [isLoggedIn]);

  return (
    <UserContext.Provider
      displayName='User Context'
      value={{
        isLoading: state.isLoading,
        fetching: state.fetching,
        users: state.users,
        usersStats: state.usersStats,
        agents: state.agents,
        deleteUser,
        addUser,
        updateAgent,
        updateUser,
        deleteAgent
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUsers = () => useContext(UserContext);
